import { getSlideWH } from './utils';
import XmlToSvg from '@tencent/xml-to-svg';
import { PLAY_MODE } from './constants';

const getPathStr = (timeNode, playMode = PLAY_MODE.play): string  => {
    let pathStr = '';
    if (playMode === PLAY_MODE.play) {
        const { childTnLst = [] } = timeNode?.anim || {};
        if (!childTnLst.length) return '';
        const [{ path }] = childTnLst;
        pathStr = path;
    } else {
        pathStr = timeNode?.props?.path;
    }
    return pathStr;
};

const findPathFirstAndEndPoint = (timeNode, playMode = PLAY_MODE.play) => {
    const { slideWidth = 1920, slideHeight = 1080 } = getSlideWH();
    const pathStr = getPathStr(timeNode, playMode);
    if (!pathStr) return {};
    const xts = new XmlToSvg(pathStr).scale(slideWidth, slideHeight)
        .serialize();
    const startPos = xts.getFirstPointPosition();
    const endPos = xts.getEndPointPosition();

    return {
        startPos,
        endPos,
    };
};


export const setPathFromStyle = (timeNode, playMode = PLAY_MODE.play): any => {
    const { startPos: { xPos = 0, yPos = 0 } = {} } = findPathFirstAndEndPoint(timeNode, playMode);
    return {
        translateX: xPos,
        translateY: yPos,
    };
};

export const setPathToStyle = (timeNode, playMode = PLAY_MODE.play) => {
    const { endPos: { xPos = 0, yPos = 0 } = {} } = findPathFirstAndEndPoint(timeNode, playMode);
    return {
        translateX: xPos,
        translateY: yPos,
    };
};
